var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dtd-search"},[(!_vm.dtdCompanySelected)?_c('h5',{staticClass:"dtd-title"},[_vm._v("See if your company will match your donation!")]):_vm._e(),_c('div',{class:{ 'dtd-company-selected': _vm.dtdCompanySelected },attrs:{"id":"dd-company-name-input"}}),_c('button',{on:{"click":_vm.test}},[_vm._v("TEST")])])
}
var staticRenderFns = []

export { render, staticRenderFns }